import UserInGroup from "./UserInGroup"

/**
 * Wrapper for UserInGroup. Contains all needed dom elements of user row
 * @param div user row
 * @param checkbox checkbox on user row
 * @param ddWrapper drag and drop class for this user row
 * @param controller user group management controller
 * @param user UserInGroup instance for wrapping
 */
export default class UserInGroupRow extends UserInGroup {
    constructor(div, checkbox, ddWrapper, controller, user) {
        super(user.id, user.name, user.active);
        this.div = div;
        this.checkbox = checkbox;
        this.ddWrapper = ddWrapper;
        this.generateEventHandlers(controller);
        this.enableControls();
    }

    /**
     * Is this user selected or not
     */
    isSelected() {
        return this.checkbox.checked;
    }

    /**
     * Hide this user
     */
    hide() {
        this.div.style.display = 'none';
    }

    /**
     * Make this user visible
     */
    open() {
        this.div.style.display = '';
    }

    /**
     * Generate all event handlers needed for this user row
     * @param controller user group management controller
     */
    generateEventHandlers(controller) {
        this.checkBoxOnClick = () => controller.passiveEventHandler(() => controller.getUserController().selectUser(this), true);
    }

    /**
     * Enable all event handlers. Calls to initialize row
     */
    enableControls() {
        this.checkbox.onclick = this.checkBoxOnClick;
    }
}


// WEBPACK FOOTER //
// ./web/js/groupManagement/entities/UserInGroupRow.js